import { ClassificationLevel } from '@sonar-software/sonar-core';
import { ClassificationTag } from './ClassificationTag';
import { enumStringKeys } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { OptionFilter } from '@periscopes/general/filters';
const optionRender = (value) => (value ?
    React.createElement(ClassificationTag, { classification: value }) : undefined);
const options = enumStringKeys(ClassificationLevel).map((label) => ({
    label,
    value: ClassificationLevel[label]
}));
export const ClassificationBulkSelector = ({ onChange, value }) => React.createElement(OptionFilter, { labelRender: (option) => optionRender(option.value), onChange: onChange, optionRender: (option) => optionRender(option.value), options: options, placeholder: COPY_GENERIC.SELECT(COPY_SPECIFIC.CLASSIFICATION), value: value });
